import { redirect } from '@tanstack/react-router'

// Route guard for authenticated routes - use with beforeLoad
export function requireAuth({ context, location }: { context: any; location: any }) {
  // Validate auth state against localStorage to catch manual deletions
  const isValidAuth = context.auth?.validateAuth?.() || context.auth?.isAuthenticated;
  
  if (!isValidAuth) {
    throw redirect({
      to: '/login',
      replace: true,
      search: {
        // Save current location for redirect after login
        redirect: location.href,
      },
    })
  }
}

// Route guard for guest-only routes (like login) - use with beforeLoad  
export function requireGuest({ context, search }: { context: any; search?: any }) {
  // Validate auth state to ensure accurate authentication status
  const isValidAuth = context.auth?.validateAuth?.() || context.auth?.isAuthenticated;
  
  if (isValidAuth) {
    throw redirect({
      to: search?.redirect || '/',
      replace: true,
    })
  }
}
